import React from 'react';
import './index.scss';
export const MaterialCheckbox = ({ label = '', ...props }) => (
  <label className='pure-material-checkbox'>
    <input type='checkbox' {...props} />
    <span>{label}</span>
  </label>
);
